export const ReshipmentModalType =  Object.freeze({
	CREATE: "CREATE_RESHIPMENT",
	REQUEST: "REQUEST_RESHIPMENT",
	DELETE: "DELETE_RESHIPMENT",
	SEND: "SEND_RESHIPMENT"
});

export const Currency = Object.freeze({
	EUR: "EUR",
	UNKNOWN: "UNKNOWN",
});

export const ReshipmentStatus = Object.freeze({
	CREATED: "CREATED",
	REQUESTED: "REQUESTED",
	APPROVED: "APPROVED",
	REJECTED: "REJECTED",
	SENT: "SENT",
});

export type CurrencyModel = {
	currencyCode: $Keys<typeof Currency>,
	currencySymbol: string,
}

export type PriceModel = {
	value: number,
	currency: CurrencyModel,
}

export type ReshipmentModelItem = {
	id: number,
	name: string,
	partNumber: string,
	vin: string,
	singlePrice: PriceModel,
	singleRefundPrice: PriceModel,
	batchPrice: PriceModel,
	refundPrice: PriceModel,
	reason: string,
	orderedAmount: number,
	requestedAmount: number,
	approvedAmount: number,
	isEdited: boolean,
	isAmountEdited: boolean,
	isPriceEdited: boolean,
	excludedFromReshipment: boolean,
	storageFee: number
}

export type ReshipmentModel = {
	id: number,
	items: ReshipmentModelItem[],
	orderNumber: string,
	reshipmentNumber: string,
	dealerNumber: string,
	dealerName: string,
	contactEmail: string,
	contactPerson: string,
	comment: string,
	status: $Keys<typeof ReshipmentStatus>,
	bundlePrice: PriceModel,
	currency: CurrencyModel,
	creationDate: Date,
	deadlineDate: Date,
	shippingLabels: string[],
	valid: boolean,
	refundPrice: PriceModel,
	hasEditedItem: boolean,
	hasExcludedItem: boolean,
	orderDate: Date,
	hasValidOrderDate: boolean,
	hasValidItemBatchPrices: boolean
}

export type CreateReshipmentRequestModel = {
	orderNumber: string,
	orderDate: Date,
	item: ReshipmentModelItem,
}

export type SendReshipmentRequestModel = {
	reshipmentId: number,
	contactPerson: string,
	contactEmail: string,
}

export type DeleteReshipmentModel = {
	id: number,
}

export type DeleteReshipmentItemModel = {
	id: number,
}

export type SendReshipmentSendModel = {
	reshipmentId: number,
	shipmentLabels: string[]
}

export type UpdateReshipmentItemRequestModel = {
	itemId: number,
	newItemAmount: number
}